import VProgress from './index.vue'

export default {
	install (Vue, options = {}) {
		
		let progress = null;
		
		const VueProgress = Vue.extend(VProgress);

		function $progress(params = {}, visible = false) {
			
			if (!progress) {
				
				progress = new VueProgress();

				progress.$mount();
				
				document.querySelector(options.container || 'body').appendChild(progress.$el);
			}

			return progress.show(params, visible, this);
		}

		Vue.prototype.$progress = $progress;
	}
}